var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-date-picker',{attrs:{"mode":_vm.mode,"min-date":_vm.minDate,"max-date":_vm.maxDate,"select-attribute":_vm.selectAttribute,"value":_vm.value,"is-inline":""},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }